import { render, staticRenderFns } from "./TrafficHomeOne.vue?vue&type=template&id=60c8ea01"
import script from "./TrafficHomeOne.vue?vue&type=script&lang=js"
export * from "./TrafficHomeOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports